<div [className]="'logout'">
  <div class="form-signin text-center">
    <div>
      <ng-container *ngIf="isJTGO;else other_than_jtgo">
        <img class="mb-4" src="assets/images/JT-GO-Master-Logo-RGB.png" alt="Jobtrain Login" width="200">
      </ng-container>
      <ng-template #other_than_jtgo>
        <img class="mb-4" src="assets/images/JT_signin_Logo.gif" alt="Jobtrain Login" width="200" data-testid="img-default-logo">
      </ng-template>
    </div>
    <div class="w-100">
      <div class="okta-logout sso-login" *ngIf="ssoConfig && ssoConfig.SingleSignOn === 'Yes'">
        <button *ngIf="ssoConfig !==null && ssoConfig.SingleSignOn_Type === 'Okta'" class="btn btn-lg btn-cas-login btn-block btn_cas_login mt-2" href="#" (click)="OktaLogin()">{{'Login.OktaLogin' | translate}}</button>
      </div>
      <ng-container *ngIf="showMobileLink">
        <br />
        <p class="text-center mt-5 mobilelink"><a *ngIf="showMobileLink" href="#" data-testid="p-goto-mobile-version" (click)="goToMobile()">{{ 'Login.GoToMobileVersion' | translate }}</a></p>
      </ng-container>
    </div>
    <br />
    <p class="text-muted" data-testid="p-copyright" [ngClass]="{'resetParagraphMargin': showMobileLink}">&copy; {{ copyRight }}</p>
  </div>
</div>

